import * as React from "react";

import "./Container.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface ContainerProps extends ComponentBaseProps {
  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
  direction?: "horizontal" | "vertical";
  justify?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly";
}

export class Container extends ComponentBase<ContainerProps> {
  render() {
    const { children, classNames, direction, justify, align, configName } =
      this.props;

    const computedStyle: React.CSSProperties = {
      ...this.props.style,
    };

    if (direction) {
      computedStyle.flexDirection = direction === "vertical" ? "column" : "row";
    }

    if (align) {
      computedStyle.alignItems = align;
    }
    if (justify) {
      computedStyle.justifyContent = justify;
    }

    const style: React.CSSProperties = {
      ...computedStyle,
      ...this.props.style,
    };

    return (
      <div
        id={configName}
        onAnimationEnd={this.resetAnimation}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        className={`Container-container ${classNames || ""} ${
          this.state.animationClass
        }`}
        style={style}
        // aria-label={get(this.props, "label", "")}
        ref={(component) => (this.component = component)}
      >
        {children}
      </div>
    );
  }
}
